import { Component } from '@angular/core';

@Component({
  selector: 'app-anonymous-header',
  templateUrl: './anonymous-header.component.html'
})
export class AnonymousHeaderComponent {}
